import React from 'react';
import imgFriendly from '../assets/img/avatar-friendly.webp';
import imgNeutral from '../assets/img/avatar-neutral.webp';
import imgReserved from '../assets/img/avatar-reserved.webp';
import imgHard from '../assets/img/avatar-hard.webp';

// Illustrated partner portraits + per-persona palette (matches each portrait's backdrop).
const PALETTES = {
  friendly: { from: '#F7CE68', to: '#EFAA37', glow: 'rgba(239,170,55,0.35)', tint: '#FFF4D6' },  // Aisha — warm sun
  neutral:  { from: '#B4CBA4', to: '#7E9D6E', glow: 'rgba(126,157,110,0.35)', tint: '#EDF3E7' }, // Priya — calm sage
  reserved: { from: '#C9BDE8', to: '#9C8BC9', glow: 'rgba(156,139,201,0.35)', tint: '#F3F0FA' }, // Meera — quiet lavender
  hard:     { from: '#E88B6F', to: '#C25037', glow: 'rgba(194,80,55,0.40)', tint: '#FBE9E3' },   // Tara — bold terracotta
};

const NAMES = { friendly: 'Aisha', neutral: 'Priya', reserved: 'Meera', hard: 'Tara' };
const IMAGES = { friendly: imgFriendly, neutral: imgNeutral, reserved: imgReserved, hard: imgHard };

export default function PersonaAvatar({ persona = 'friendly', size = 64, speaking = false, ring = false }) {
  const p = PALETTES[persona] || PALETTES.friendly;
  return (
    <div
      className={`relative rounded-full shrink-0 select-none overflow-hidden ${speaking ? 'animate-orb-breathe' : ''} ${ring ? 'ring-4 ring-ember ring-offset-2 ring-offset-bg' : ''}`}
      style={{
        width: size, height: size,
        background: `radial-gradient(120% 120% at 30% 25%, ${p.from} 0%, ${p.to} 75%)`,
        boxShadow: speaking ? `0 0 ${size / 2.5}px ${p.glow}` : `0 6px 18px ${p.glow}`,
      }}
      data-testid={`persona-avatar-${persona}`}
    >
      <img
        src={IMAGES[persona] || IMAGES.friendly}
        alt={NAMES[persona] || 'partner'}
        className="absolute inset-0 w-full h-full object-cover"
        draggable={false}
      />
    </div>
  );
}

export { NAMES as PERSONA_NAMES, PALETTES as PERSONA_PALETTES };
